




































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";

import { STORE_KEY, store } from "../ProductForm/_store";
import { resolveCatalogEntityId } from "../utils/openCatalogEntity";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "document",
      "form",
      "meta",
      "savedBusinessScopes",
      "parentProductName"
    ]),
    ...mapGetters(STORE_KEY, ["fields"])
  }
})
export default class ProductViewForm extends Vue {
  @Prop({ type: Object }) documentPreview!: any;

  document!: any;
  form!: any;
  meta!: any;
  savedBusinessScopes!: any[];
  parentProductName!: string | null;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    const entityId = resolveCatalogEntityId(this, this.documentPreview);
    if (entityId != null) {
      this.$store.dispatch(`${STORE_KEY}/init`, { id: entityId });
    }
  }

  get typeName() {
    if (this.parentProductName) {
      return this.parentProductName;
    }
    if (this.documentPreview && this.documentPreview.parent_product_name) {
      return this.documentPreview.parent_product_name;
    }
    if (
      this.form &&
      this.form.type_id &&
      this.meta &&
      this.meta.products_types
    ) {
      const type = this.meta.products_types.find(
        (t: any) => t.id === this.form.type_id
      );
      return type ? type.name : "-";
    }
    return "-";
  }

  get tradeMarkName() {
    if (this.documentPreview && this.documentPreview.trade_mark_name) {
      return this.documentPreview.trade_mark_name;
    }
    if (
      this.form &&
      this.form.trade_mark_id &&
      this.meta &&
      this.meta.product_trade_marks
    ) {
      const tradeMark = this.meta.product_trade_marks.find(
        (tm: any) => tm.id === this.form.trade_mark_id
      );
      return tradeMark ? tradeMark.name : "-";
    }
    return "-";
  }

  get businessScopesText() {
    if (this.savedBusinessScopes && this.savedBusinessScopes.length) {
      const names = this.savedBusinessScopes
        .map((scope: any) => scope.name)
        .filter(Boolean);
      if (names.length) {
        return names.join(", ");
      }
    }
    if (this.documentPreview && this.documentPreview.business_scopes) {
      if (Array.isArray(this.documentPreview.business_scopes)) {
        return this.documentPreview.business_scopes
          .map((s: any) => s.name)
          .join(", ");
      }
    }
    if (
      this.form &&
      this.form.business_scope_ids &&
      this.meta &&
      this.meta.business_scopes
    ) {
      return this.form.business_scope_ids
        .map((id: any) => {
          const scope = this.meta.business_scopes.find((s: any) => s.id === id);
          return scope ? scope.name : "";
        })
        .filter(Boolean)
        .join(", ");
    }
    return "-";
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
  }
}
